module.exports = __webpack_public_path__ + "assets/img/qian.52efe31e.png";